import { Injectable } from '@angular/core';
import { SecurityHelper } from '../../../../pages/common/securityHelper';


export interface NavigationItem {
  id: string;
  moduleName?: string;
  moduleAccessID?: number;
  title: string;
  type: 'item' | 'collapse' | 'group';
  translate?: string;
  icon?: string;
  iconColor?: string;
  hidden?: boolean;
  url?: string;
  classes?: string;
  exactMatch?: boolean;
  external?: boolean;
  target?: boolean;
  breadcrumbs?: boolean;
  function?: any;
  badge?: {
    title?: string;
    type?: string;
  };
  children?: Navigation[];
}

export interface Navigation extends NavigationItem {
  children?: NavigationItem[];
}

@Injectable()
export class NavigationItem {

  navigationItems: any[] = [];

  public get() {

    let navigationItems: any = [];

    if (SecurityHelper.GetLoggedInUserDto()) {

      navigationItems = this.navigationItems;

    }

    return navigationItems;
  }

  public getPageNameByURL(url: string): string {

    let pageFound = this.search(url, this.navigationItems);

    return (pageFound != null) ? pageFound.title : url;
  }

  public hasPageAccess(url: string): boolean {

    let pageFound = this.search(url, this.navigationItems);

    return (pageFound != null);
  }

  private search(searchUrl: string, items: NavigationItem[]): NavigationItem | null {

    let hasAccess = false;

    // remove query string parameter
    searchUrl = searchUrl.split('?')[0];

    for (const item of items) {

      // special case for IVI Home with dynamic children
      if (item.url && item.url == this.navigationItems[0].children[0].url && searchUrl.indexOf(item.url) >= 0) {
        return item;
      }

      if (item.url === searchUrl) {
        return item;
      }

      if (item.children) {
        const result = this.search(searchUrl, item.children);
        if (result) {
          return result;
        }
      }
    }

    // If not found
    return null;
  }

}
